/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UsersFindAllResponse } from './UsersFindAllResponse';
import {
    UsersFindAllResponseFromJSON,
    UsersFindAllResponseFromJSONTyped,
    UsersFindAllResponseToJSON,
    UsersFindAllResponseToJSONTyped,
} from './UsersFindAllResponse';
import type { UserGroup } from './UserGroup';
import {
    UserGroupFromJSON,
    UserGroupFromJSONTyped,
    UserGroupToJSON,
    UserGroupToJSONTyped,
} from './UserGroup';

/**
 * 
 * @export
 * @interface MentionSuggestionsResponse
 */
export interface MentionSuggestionsResponse {
    /**
     * 
     */
    users: UsersFindAllResponse;
    /**
     * 
     */
    user_groups: Array<UserGroup>;
    /**
     * 
     */
    user_groups_has_more: boolean;
}

/**
 * Check if a given object implements the MentionSuggestionsResponse interface.
 */
export function instanceOfMentionSuggestionsResponse(value: object): value is MentionSuggestionsResponse {
    if (!('users' in value) || value['users'] === undefined) return false;
    if (!('user_groups' in value) || value['user_groups'] === undefined) return false;
    if (!('user_groups_has_more' in value) || value['user_groups_has_more'] === undefined) return false;
    return true;
}

export function MentionSuggestionsResponseFromJSON(json: any): MentionSuggestionsResponse {
    return MentionSuggestionsResponseFromJSONTyped(json, false);
}

export function MentionSuggestionsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MentionSuggestionsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'users': UsersFindAllResponseFromJSON(json['users']),
        'user_groups': ((json['user_groups'] as Array<any>).map(UserGroupFromJSON)),
        'user_groups_has_more': json['user_groups_has_more'],
    };
}

export function MentionSuggestionsResponseToJSON(json: any): MentionSuggestionsResponse {
    return MentionSuggestionsResponseToJSONTyped(json, false);
}

export function MentionSuggestionsResponseToJSONTyped(value?: MentionSuggestionsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'users': UsersFindAllResponseToJSON(value['users']),
        'user_groups': ((value['user_groups'] as Array<any>).map(UserGroupToJSON)),
        'user_groups_has_more': value['user_groups_has_more'],
    };
}

